import React from "react";

function Browse({ data }) {
  return (
    <div className="browse section">
      <h2 className="otherhead">Browse</h2>
      <div className="panel">
        {data ? (
          <pre>{data.site_text}</pre>
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );
}

export default Browse;
